import { ERROR_LOGS_LIST_LIMIT } from 'data/error-log-constants';
import { ErrorLogListItemType, ErrorLogType } from 'types/error-log';
import { emptyApi } from './empty-api';

const errorLogApi = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getErrorLogs: builder.query<ErrorLogListItemType[], void>({
      query: () => `admin/error-logs?limit=${ERROR_LOGS_LIST_LIMIT}`,
      providesTags: ['ErrorLogs']
    }),
    getErrorLog: builder.query<ErrorLogType, number>({
      query: (id) => `admin/error-logs/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'ErrorLogs', id }]
    })
  })
});

export const {
  useGetErrorLogsQuery,
  useGetErrorLogQuery,
  useLazyGetErrorLogQuery
} = errorLogApi;
